import { render, staticRenderFns } from "./ktpMessage.vue?vue&type=template&id=2118e4dc&scoped=true"
import script from "./ktpMessage.vue?vue&type=script&lang=ts"
export * from "./ktpMessage.vue?vue&type=script&lang=ts"
import style0 from "./ktpMessage.vue?vue&type=style&index=0&id=2118e4dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2118e4dc",
  null
  
)

export default component.exports